import { Request } from 'api';
import { AxiosResponse } from 'axios';

interface ScrapeJob {
    job_id: string;
    status: string;
    url: string;
    meet_name?: string;
    total_results: number;
    matched_count: number;
    created_at: string;
}

interface ScrapeJobsResponse {
    jobs: ScrapeJob[];
}

type ReturnType = Promise<AxiosResponse<ScrapeJobsResponse>>;

const getScrapeJobs = (groupUuid: string, limit: number = 10): ReturnType => {
    return Request.get('/workouts/track-events/scrape-jobs', {
        params: {
            group_uuid: groupUuid,
            limit,
        },
    });
};

export default getScrapeJobs;
